<template>
  <div v-if="meta.total_pages > 1" class="flex justify-center my-4">
    <nav aria-label="search results pagination">
      <ul class="m-0 px-2 flex h-10 bg-gray-100 dark:bg-primary-dark  border border-gray-200/50 overflow-hidden">

        <li v-if="meta.current_page > 2">
          <a
            @click="$emit('first')"
            class="flex py-2 px-4 h-full font-bold text-sm leading-none items-center border-r cursor-pointer"
            aria-label="First Page">
            <span aria-hidden="true">&laquo;</span>&nbsp;First
          </a>
        </li>

        <li v-if="meta.current_page > 1">
          <a
            @click="$emit('prev')"
            class="flex py-2 px-4 h-full font-semibold text-sm leading-none items-center border-r cursor-pointer"
            aria-label="Previous Page">
            <span aria-hidden="true">&laquo;</span>&nbsp;Previous
          </a>
        </li>

        <li v-if="meta.total_pages > 1">
          <span class="flex py-2 px-5 h-full text-sm text-white leading-none items-center" >
            {{ meta.current_page }} of {{ meta.total_pages }}
          </span>
        </li>

        <li v-if="meta.current_page < meta.total_pages">
          <a
            @click="$emit('next')"
            class="flex py-2 px-5 h-full font-semibold text-sm leading-none items-center border-l border-gray-200/50 cursor-pointer"
            aria-label="Next Page">
            Next&nbsp;<span aria-hidden="true">&raquo;</span>
          </a>
        </li>

        <li v-if="meta.current_page < meta.total_pages - 1">
          <a
            @click="$emit('last')"
            class="flex py-2 px-5 h-full font-semibold text-sm leading-none items-center border-l border-gray-200/50 cursor-pointer"
            aria-label="Last Page">
            Last&nbsp;<span aria-hidden="true">&raquo;</span>
          </a>
        </li>

      </ul>
    </nav>
  </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: "PropertySearchPagination",

  setup() {

  },

  props: {
    meta: {
      type: Object,
      default: () => {}
    }
  },


})
</script>
